import React from 'react'

import Icon from '@/components/common/Icon'

const IconLoyalCustomer: React.FC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width, height }) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 13 12"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.10714 11.0422L5.39759 10.4043C4.33195 9.43757 3.4507 8.60684 2.75384 7.91212C2.05698 7.2173 1.50477 6.59893 1.0972 6.057C0.689625 5.51518 0.404893 5.02087 0.243 4.57409C0.0810001 4.12741 0 3.67414 0 3.21429C0 2.30196 0.307607 1.53814 0.922822 0.922821C1.53814 0.307607 2.30196 0 3.21429 0C3.7755 0 4.30586 0.13125 4.80536 0.39375C5.30486 0.65625 5.73879 1.0327 6.10714 1.52309C6.4755 1.0327 6.90943 0.65625 7.40893 0.39375C7.90843 0.13125 8.43879 0 9 0C9.91232 0 10.6761 0.307607 11.2915 0.922821C11.9067 1.53814 12.2143 2.30196 12.2143 3.21429C12.2143 3.67414 12.1333 4.12741 11.9713 4.57409C11.8094 5.02087 11.5247 5.51518 11.1171 6.057C10.7095 6.59893 10.1583 7.2173 9.4635 7.91212C8.76879 8.60684 7.88652 9.43757 6.8167 10.4043L6.10714 11.0422Z"
      fill="currentColor"
    />
  </svg>
)

export default Icon(IconLoyalCustomer)
